import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/staff/u')({
  loader: () => ({
    crumb: 'Users',
  }),
})
